import EmployeeLoyaltyLeaderboard from './EmployeeLoyaltyLeaderboard';
export default EmployeeLoyaltyLeaderboard;